function UserRanking({ name, position }) {
    return (
      <div className="flex items-center">
        <div className="w-8 h-8 rounded-full bg-yellow-400 flex items-center justify-center mr-2">
          <div className="w-full h-full rounded-full bg-gray-300"></div>
        </div>
        <span className="text-sm mr-2">{position}° - </span>
        <span className="text-sm">{name}</span>
      </div>
    );
  }

  export default UserRanking;